import axios from "axios";

export default function EmployeedocumentGenerateService(employeeId, templateId, wildcards) {
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/employee/" + employeeId + "/create-document-template/" + templateId,
    data: {
      extrafields: wildcards
    },
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
